import { render } from "./SiteVitrineDesktop.vue?vue&type=template&id=856d56d6"
import script from "./SiteVitrineDesktop.vue?vue&type=script&lang=js"
export * from "./SiteVitrineDesktop.vue?vue&type=script&lang=js"

import "./SiteVitrineDesktop.vue?vue&type=style&index=0&id=856d56d6&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__